export default function About() {
  return (
    <>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-8px) scale(1.03); }
        }
        @keyframes shimmer {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
        .bubble { animation: float 4s ease-in-out infinite; }
        .bubble-shimmer { animation: shimmer 3s ease-in-out infinite; }
      `}</style>

      <section className="py-16 px-4">
        <div className="sm:w-11/12 mx-auto">
          <div className="grid grid-cols-5 gap-6">

            {/* Left Card - 2/5 width */}
            <div className="col-span-5 md:col-span-2 rounded-3xl overflow-hidden order-2 md:order-1">
              <img
                src="/Frame5.png"
                alt="Bluekite services"
                className="w-full h-full object-cover block"
              />
            </div>

            {/* Right Card - 3/5 width */}
            <div className="col-span-5 md:col-span-3 rounded-3xl overflow-hidden border border-gray-100 shadow-sm bg-white order-1 md:order-2 relative">
              <img
                src="/Frame_61.jpg"
                alt="Branding X PR Agency"
                className="w-full h-full object-cover block"
              />

              {/* Animated transparent bubble */}
              <div
                className="bubble absolute left-[50%] top-[48%] -translate-y-1/2 z-10 w-24 h-24 sm:w-32 sm:h-32 rounded-full"
                style={{
                  background: "radial-gradient(circle at 35% 35%, rgba(255,255,255,0.95) 0%, rgba(220,230,255,0.4) 40%, rgba(180,200,255,0.15) 70%, rgba(100,150,255,0.05) 100%)",
                  boxShadow: "inset -4px -4px 12px rgba(255,255,255,0.6), inset 4px 4px 12px rgba(100,150,255,0.2), 0 8px 32px rgba(100,150,255,0.15)",
                  backdropFilter: "blur(4px)",
                  border: "1px solid rgba(255,255,255,0.6)",
                }}
              >
                <div
                  className="bubble-shimmer absolute top-2 left-2 w-8 h-8 rounded-full"
                  style={{
                    background: "radial-gradient(circle, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0) 100%)",
                    filter: "blur(3px)",
                  }}
                />
                <div
                  className="absolute top-3 left-4 w-2 h-2 rounded-full"
                  style={{ background: "rgba(255,255,255,1)", filter: "blur(1px)" }}
                />
              </div>

              {/* Rotating stamp badge */}
              <div className="absolute right-[12%] top-[45%] z-10">
                <img
                  src="/Group_39.png"
                  alt="Bluekite Consults stamp"
                  className="w-16 h-16 sm:w-20 sm:h-20 object-contain animate-spin"
                  style={{ animationDuration: "10s" }}
                />
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}